export default __webpack_public_path__ + "static/media/icon-smartwatch.cd194b51.svg";